//libs
import React, { memo } from 'react';

// global components
import RouteChunkRenderer from 'shared/components/RouteChunkRenderer';
import ChunkFallback from 'shared/components/ChunkFallback';
import RedirectToHomePage from 'shared/components/RedirectToHomePage';

// components
import MyAccountMobile from 'shared/layouts/MyAccountPage/Mobile';

function MyAccount() {
  return (
    <RouteChunkRenderer
      mobileComponent={<MyAccountMobile fallback={<ChunkFallback />} />}
      desktopComponent={<RedirectToHomePage />}
    />
  );
}

export default memo(MyAccount);
